import LeadershipBonusesShell from "../Shell/LeadershipBonuseShell";
import FloatingSupportButton from "../../../components/FloatingSupportButton";
import { Box } from "@mui/material";

export default function AgentLeadershipBonuses() {
	const stored = localStorage.getItem("loggedin_data");
	const user = stored ? JSON.parse(stored) : null;

	return (
		<Box>
			<LeadershipBonusesShell activeAgentId={null} isAgent={true} loggedInAgentName={`${user?.name} ${user?.last_name}`} />
			<FloatingSupportButton />
		</Box>
	);
}
